<template>
  <g fill="transparent">
    <mask id="mask-icon-faq-balloon" :fill="bgColor">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.1318 15.5892C21.6903 14.4896 22 13.2758 22 12C22 7.02944 17.299 3 11.5 3C5.70101 3 1 7.02944 1 12C1 16.9706 5.70101 21 11.5 21C13.9699 21 16.2407 20.269 18.0339 19.0456L22.3197 20.1837C22.7273 20.2919 23.0776 19.8779 22.9033 19.4938L21.1318 15.5892Z"
      />
    </mask>
    <path
      d="M21.1318 15.5892L19.3486 14.6835L18.9134 15.5404L19.3105 16.4156L21.1318 15.5892ZM18.0339 19.0456L18.5472 17.1126L17.6627 16.8778L16.9067 17.3935L18.0339 19.0456ZM22.3197 20.1837L21.8064 22.1167L21.8064 22.1167L22.3197 20.1837ZM22.9033 19.4938L21.082 20.3202H21.082L22.9033 19.4938ZM20 12C20 12.9461 19.7715 13.8509 19.3486 14.6835L22.915 16.4949C23.6091 15.1284 24 13.6055 24 12H20ZM11.5 5C16.4948 5 20 8.41214 20 12H24C24 5.64674 18.1032 1 11.5 1V5ZM3 12C3 8.41214 6.50523 5 11.5 5V1C4.89679 1 -1 5.64674 -1 12H3ZM11.5 19C6.50523 19 3 15.5879 3 12H-1C-1 18.3533 4.89679 23 11.5 23V19ZM16.9067 17.3935C15.4534 18.385 13.5771 19 11.5 19V23C14.3628 23 17.028 22.153 19.161 20.6978L16.9067 17.3935ZM22.833 18.2507L18.5472 17.1126L17.5206 20.9787L21.8064 22.1167L22.833 18.2507ZM21.082 20.3202C20.5592 19.1679 21.6101 17.926 22.833 18.2507L21.8064 22.1167C23.8445 22.6579 25.5959 20.5879 24.7246 18.6675L21.082 20.3202ZM19.3105 16.4156L21.082 20.3202L24.7246 18.6675L22.9531 14.7629L19.3105 16.4156Z"
      :fill="iconColor"
      mask="url(#mask-icon-faq-balloon)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7172 10.7188C11.0814 11.4685 10.3579 12.3216 10.5524 13.6377H12.3288C12.222 12.6243 12.8064 11.9541 13.4005 11.2727C13.9637 10.6269 14.5355 9.97114 14.5355 9.00375C14.5355 7.21175 13.3142 6.34375 11.6488 6.34375C10.4414 6.34375 9.45604 6.91775 8.73438 7.74375L9.85851 8.77975C10.3026 8.31775 10.7884 7.99575 11.399 7.99575C12.1207 7.99575 12.5787 8.44375 12.5787 9.14375C12.5787 9.70298 12.1702 10.1846 11.7172 10.7188ZM10.1758 16.0159C10.1758 16.7719 10.717 17.3599 11.4387 17.3599C12.1743 17.3599 12.7155 16.7719 12.7155 16.0159C12.7155 15.2599 12.1743 14.6719 11.4387 14.6719C10.717 14.6719 10.1758 15.2599 10.1758 16.0159Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: "#ffffff"
    },

    iconColor: {
      type: String,
      default: "#3c3c3c"
    }
  }
};
</script>
